/* tslint:disable */
/* eslint-disable */
/**
 * Raunfærnimat vefur
 * Raunfærnimat vefþjónustur fyrir vef
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Sveinsprófsgreinar fyrir umsókn.
 * @export
 * @interface ApplicationEducationIndustry
 */
export interface ApplicationEducationIndustry {
    /**
     * 
     * @type {string}
     * @memberof ApplicationEducationIndustry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationEducationIndustry
     */
    name: string;
}
/**
 * Annað nám fyrir umsóknir
 * @export
 * @interface ApplicationEducationOther
 */
export interface ApplicationEducationOther {
    /**
     * 
     * @type {string}
     * @memberof ApplicationEducationOther
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationEducationOther
     */
    name: string;
}
/**
 * Greinar fyrir umsókn.
 * @export
 * @interface ApplicationIndustry
 */
export interface ApplicationIndustry {
    /**
     * 
     * @type {string}
     * @memberof ApplicationIndustry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationIndustry
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationIndustry
     */
    requiresPensionfundFile?: boolean;
}
/**
 * Svara spurningum
 * @export
 * @interface ApplicationQuestionnaireAnswerInputItemRequest
 */
export interface ApplicationQuestionnaireAnswerInputItemRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireAnswerInputItemRequest
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationQuestionnaireAnswerInputItemRequest
     */
    answer: number;
}
/**
 * Svara spurningum
 * @export
 * @interface ApplicationQuestionnaireAnswerInputRequest
 */
export interface ApplicationQuestionnaireAnswerInputRequest {
    /**
     * 
     * @type {Array<ApplicationQuestionnaireAnswerInputItemRequest>}
     * @memberof ApplicationQuestionnaireAnswerInputRequest
     */
    answers: Array<ApplicationQuestionnaireAnswerInputItemRequest>;
}
/**
 * 
 * @export
 * @interface ApplicationQuestionnaireAssessmentCategoryRelated
 */
export interface ApplicationQuestionnaireAssessmentCategoryRelated {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireAssessmentCategoryRelated
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationQuestionnaireAssessmentCategoryRelated
     */
    approved: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireAssessmentCategoryRelated
     */
    categoryId?: string;
}
/**
 * 
 * @export
 * @interface ApplicationQuestionnaireAssessmentRelated
 */
export interface ApplicationQuestionnaireAssessmentRelated {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireAssessmentRelated
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireAssessmentRelated
     */
    comments?: string;
    /**
     * 
     * @type {Array<ApplicationQuestionnaireAssessmentCategoryRelated>}
     * @memberof ApplicationQuestionnaireAssessmentRelated
     */
    categories: Array<ApplicationQuestionnaireAssessmentCategoryRelated>;
}
/**
 * 
 * @export
 * @interface ApplicationQuestionnaireAssessmentRelatedRequest
 */
export interface ApplicationQuestionnaireAssessmentRelatedRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireAssessmentRelatedRequest
     */
    comments?: string;
}
/**
 * Svarlisti spurningalista
 * @export
 * @interface ApplicationQuestionnaireDetail
 */
export interface ApplicationQuestionnaireDetail {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireDetail
     */
    id: string;
    /**
     * 
     * @type {ApplicationRelated}
     * @memberof ApplicationQuestionnaireDetail
     */
    application: ApplicationRelated;
    /**
     * 
     * @type {ApplicationQuestionnaireListQuestionnaire}
     * @memberof ApplicationQuestionnaireDetail
     */
    questionnaire: ApplicationQuestionnaireListQuestionnaire;
    /**
     * 
     * @type {Array<ApplicationQuestionnaireListCategory>}
     * @memberof ApplicationQuestionnaireDetail
     */
    categories: Array<ApplicationQuestionnaireListCategory>;
    /**
     * 
     * @type {Array<ApplicationQuestionnaireListAnswer>}
     * @memberof ApplicationQuestionnaireDetail
     */
    answers: Array<ApplicationQuestionnaireListAnswer>;
    /**
     * 
     * @type {Array<ApplicationQuestionnaireAssessmentRelated>}
     * @memberof ApplicationQuestionnaireDetail
     */
    assessments: Array<ApplicationQuestionnaireAssessmentRelated>;
    /**
     * 
     * @type {ApplicationQuestionnaireStatusEnum}
     * @memberof ApplicationQuestionnaireDetail
     */
    status?: ApplicationQuestionnaireStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireDetail
     */
    interviewLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireDetail
     */
    interviewDateTime?: string | null;
}
/**
 * Svarlisti spurningalista
 * @export
 * @interface ApplicationQuestionnaireDetailRequest
 */
export interface ApplicationQuestionnaireDetailRequest {
    /**
     * 
     * @type {ApplicationRelatedRequest}
     * @memberof ApplicationQuestionnaireDetailRequest
     */
    application: ApplicationRelatedRequest;
    /**
     * 
     * @type {ApplicationQuestionnaireStatusEnum}
     * @memberof ApplicationQuestionnaireDetailRequest
     */
    status?: ApplicationQuestionnaireStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireDetailRequest
     */
    interviewLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireDetailRequest
     */
    interviewDateTime?: string | null;
}
/**
 * Svarlisti spurningalista
 * @export
 * @interface ApplicationQuestionnaireList
 */
export interface ApplicationQuestionnaireList {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireList
     */
    id: string;
    /**
     * 
     * @type {ApplicationRelated}
     * @memberof ApplicationQuestionnaireList
     */
    application: ApplicationRelated;
    /**
     * 
     * @type {QuestionnaireRelated}
     * @memberof ApplicationQuestionnaireList
     */
    questionnaire: QuestionnaireRelated;
}
/**
 * 
 * @export
 * @interface ApplicationQuestionnaireListAnswer
 */
export interface ApplicationQuestionnaireListAnswer {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListAnswer
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationQuestionnaireListAnswer
     */
    answer: number;
    /**
     * 
     * @type {ApplicationQuestionnaireListQuestion}
     * @memberof ApplicationQuestionnaireListAnswer
     */
    question: ApplicationQuestionnaireListQuestion;
}
/**
 * 
 * @export
 * @interface ApplicationQuestionnaireListCategory
 */
export interface ApplicationQuestionnaireListCategory {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListCategory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListCategory
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListCategory
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationQuestionnaireListCategory
     */
    order: number;
    /**
     * 
     * @type {Array<ApplicationQuestionnaireListSubcategory>}
     * @memberof ApplicationQuestionnaireListCategory
     */
    subcategories: Array<ApplicationQuestionnaireListSubcategory>;
}
/**
 * 
 * @export
 * @interface ApplicationQuestionnaireListQuestion
 */
export interface ApplicationQuestionnaireListQuestion {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestion
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestion
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestion
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestion
     */
    subcategoryId?: string | null;
}
/**
 * Matslisti tengdur svarlista
 * @export
 * @interface ApplicationQuestionnaireListQuestionnaire
 */
export interface ApplicationQuestionnaireListQuestionnaire {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestionnaire
     */
    id: string;
    /**
     * 
     * @type {QuestionnaireStatusEnum}
     * @memberof ApplicationQuestionnaireListQuestionnaire
     */
    status: QuestionnaireStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ApplicationQuestionnaireListQuestionnaire
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestionnaire
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListQuestionnaire
     */
    instructions: string;
}
/**
 * 
 * @export
 * @interface ApplicationQuestionnaireListSubcategory
 */
export interface ApplicationQuestionnaireListSubcategory {
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListSubcategory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListSubcategory
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationQuestionnaireListSubcategory
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationQuestionnaireListSubcategory
     */
    order: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationQuestionnaireStatusEnum {
    Sent = 'SENT',
    Answered = 'ANSWERED',
    Returned = 'RETURNED',
    Resubmitted = 'RESUBMITTED',
    Assessed = 'ASSESSED',
    Published = 'PUBLISHED'
}

/**
 * Umsókn tengd spurningalista
 * @export
 * @interface ApplicationRelated
 */
export interface ApplicationRelated {
    /**
     * 
     * @type {string}
     * @memberof ApplicationRelated
     */
    id: string;
    /**
     * 
     * @type {IndustryRelated}
     * @memberof ApplicationRelated
     */
    industry: IndustryRelated;
    /**
     * 
     * @type {SchoolRelated}
     * @memberof ApplicationRelated
     */
    school: SchoolRelated;
}
/**
 * Umsókn tengd spurningalista
 * @export
 * @interface ApplicationRelatedRequest
 */
export interface ApplicationRelatedRequest {
    /**
     * 
     * @type {IndustryRelatedRequest}
     * @memberof ApplicationRelatedRequest
     */
    industry: IndustryRelatedRequest;
    /**
     * 
     * @type {SchoolRelatedRequest}
     * @memberof ApplicationRelatedRequest
     */
    school: SchoolRelatedRequest;
}
/**
 * Skólar fyrir umsókn.
 * @export
 * @interface ApplicationSchool
 */
export interface ApplicationSchool {
    /**
     * 
     * @type {number}
     * @memberof ApplicationSchool
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationSchool
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationSchool
     */
    link: string;
    /**
     * 
     * @type {Array<SchoolMetadataIndustryRelated>}
     * @memberof ApplicationSchool
     */
    industries: Array<SchoolMetadataIndustryRelated>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationStatusEnum {
    Draft = 'DRAFT',
    New = 'NEW',
    OnHold = 'ON_HOLD',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED',
    Returned = 'RETURNED',
    Resubmitted = 'RESUBMITTED',
    QuestionnaireSent = 'QUESTIONNAIRE_SENT',
    Cancelled = 'CANCELLED',
    Published = 'PUBLISHED'
}

/**
 * Stéttarfélög fyrir umsókn.
 * @export
 * @interface ApplicationUnion
 */
export interface ApplicationUnion {
    /**
     * 
     * @type {string}
     * @memberof ApplicationUnion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUnion
     */
    name: string;
}
/**
 * 
 * @export
 * @interface EducationIndustryRelated
 */
export interface EducationIndustryRelated {
    /**
     * 
     * @type {string}
     * @memberof EducationIndustryRelated
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EducationIndustryRelated
     */
    name: string;
}
/**
 * 
 * @export
 * @interface EducationIndustryRelatedRequest
 */
export interface EducationIndustryRelatedRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationIndustryRelatedRequest
     */
    id: string;
}
/**
 * 
 * @export
 * @interface EducationOtherRelated
 */
export interface EducationOtherRelated {
    /**
     * 
     * @type {string}
     * @memberof EducationOtherRelated
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EducationOtherRelated
     */
    name: string;
}
/**
 * 
 * @export
 * @interface EducationOtherRelatedRequest
 */
export interface EducationOtherRelatedRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationOtherRelatedRequest
     */
    id: string;
}
/**
 * 
 * @export
 * @interface GetMe
 */
export interface GetMe {
    /**
     * 
     * @type {string}
     * @memberof GetMe
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetMe
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof GetMe
     */
    name: string;
}
/**
 * 
 * @export
 * @interface IndustryRelated
 */
export interface IndustryRelated {
    /**
     * 
     * @type {string}
     * @memberof IndustryRelated
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IndustryRelated
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof IndustryRelated
     */
    requiresPensionfundFile?: boolean;
}
/**
 * 
 * @export
 * @interface IndustryRelatedRequest
 */
export interface IndustryRelatedRequest {
    /**
     * 
     * @type {string}
     * @memberof IndustryRelatedRequest
     */
    id: string;
}
/**
 * Athugasemd á umsókn.
 * @export
 * @interface MyApplicationComment
 */
export interface MyApplicationComment {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationComment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationComment
     */
    comment?: string;
    /**
     * 
     * @type {MyApplicationCommentUserRelated}
     * @memberof MyApplicationComment
     */
    createdBy?: MyApplicationCommentUserRelated;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationComment
     */
    createdAt?: string;
}
/**
 * Athugasemdaraðili.
 * @export
 * @interface MyApplicationCommentUserRelated
 */
export interface MyApplicationCommentUserRelated {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationCommentUserRelated
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationCommentUserRelated
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationCommentUserRelated
     */
    username: string;
}
/**
 * Mínar umsóknir
 * @export
 * @interface MyApplicationDetail
 */
export interface MyApplicationDetail {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    id: string;
    /**
     * 
     * @type {MyApplicationUser}
     * @memberof MyApplicationDetail
     */
    user: MyApplicationUser;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    mobile: string;
    /**
     * 
     * @type {UnionRelated}
     * @memberof MyApplicationDetail
     */
    union?: UnionRelated | null;
    /**
     * 
     * @type {ApplicationStatusEnum}
     * @memberof MyApplicationDetail
     */
    status?: ApplicationStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetail
     */
    hasNoUnion?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetail
     */
    dontKnowUnion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    interviewLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    interviewDateTime?: string | null;
    /**
     * 
     * @type {IndustryRelated}
     * @memberof MyApplicationDetail
     */
    industry: IndustryRelated;
    /**
     * 
     * @type {SchoolRelated}
     * @memberof MyApplicationDetail
     */
    school: SchoolRelated;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetail
     */
    isContractFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetail
     */
    isJourneymanFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetail
     */
    isMatriculationFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetail
     */
    isEducationAbroadFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetail
     */
    hasOngoingContract?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    otherEducationInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetail
     */
    otherInformation?: string;
    /**
     * 
     * @type {Array<MyApplicationEducationIndustryRelated>}
     * @memberof MyApplicationDetail
     */
    education: Array<MyApplicationEducationIndustryRelated>;
    /**
     * 
     * @type {Array<MyApplicationEducationOther>}
     * @memberof MyApplicationDetail
     */
    educationOther?: Array<MyApplicationEducationOther>;
    /**
     * 
     * @type {Array<MyApplicationEducationCourse>}
     * @memberof MyApplicationDetail
     */
    course: Array<MyApplicationEducationCourse>;
    /**
     * 
     * @type {Array<MyApplicationJob>}
     * @memberof MyApplicationDetail
     */
    job: Array<MyApplicationJob>;
    /**
     * 
     * @type {Array<MyApplicationFile>}
     * @memberof MyApplicationDetail
     */
    files: Array<MyApplicationFile>;
}
/**
 * Mínar umsóknir
 * @export
 * @interface MyApplicationDetailRequest
 */
export interface MyApplicationDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetailRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetailRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetailRequest
     */
    mobile: string;
    /**
     * 
     * @type {UnionRelatedRequest}
     * @memberof MyApplicationDetailRequest
     */
    union?: UnionRelatedRequest | null;
    /**
     * 
     * @type {ApplicationStatusEnum}
     * @memberof MyApplicationDetailRequest
     */
    status?: ApplicationStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetailRequest
     */
    hasNoUnion?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetailRequest
     */
    dontKnowUnion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetailRequest
     */
    interviewLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetailRequest
     */
    interviewDateTime?: string | null;
    /**
     * 
     * @type {IndustryRelatedRequest}
     * @memberof MyApplicationDetailRequest
     */
    industry: IndustryRelatedRequest;
    /**
     * 
     * @type {SchoolRelatedRequest}
     * @memberof MyApplicationDetailRequest
     */
    school: SchoolRelatedRequest;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetailRequest
     */
    isContractFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetailRequest
     */
    isJourneymanFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetailRequest
     */
    isMatriculationFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetailRequest
     */
    isEducationAbroadFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationDetailRequest
     */
    hasOngoingContract?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetailRequest
     */
    otherEducationInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationDetailRequest
     */
    otherInformation?: string;
    /**
     * 
     * @type {Array<MyApplicationEducationIndustryRelatedRequest>}
     * @memberof MyApplicationDetailRequest
     */
    education: Array<MyApplicationEducationIndustryRelatedRequest>;
    /**
     * 
     * @type {Array<MyApplicationEducationOtherRequest>}
     * @memberof MyApplicationDetailRequest
     */
    educationOther?: Array<MyApplicationEducationOtherRequest>;
    /**
     * 
     * @type {Array<MyApplicationEducationCourseRequest>}
     * @memberof MyApplicationDetailRequest
     */
    course: Array<MyApplicationEducationCourseRequest>;
    /**
     * 
     * @type {Array<MyApplicationJobRequest>}
     * @memberof MyApplicationDetailRequest
     */
    job: Array<MyApplicationJobRequest>;
}
/**
 * Menntun á eigin umsókn.
 * @export
 * @interface MyApplicationEducationCourse
 */
export interface MyApplicationEducationCourse {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationEducationCourse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationEducationCourse
     */
    name: string;
}
/**
 * Menntun á eigin umsókn.
 * @export
 * @interface MyApplicationEducationCourseRequest
 */
export interface MyApplicationEducationCourseRequest {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationEducationCourseRequest
     */
    name: string;
}
/**
 * Iðngrein á eigin umsókn.
 * @export
 * @interface MyApplicationEducationIndustryRelated
 */
export interface MyApplicationEducationIndustryRelated {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationEducationIndustryRelated
     */
    id: string;
    /**
     * 
     * @type {EducationIndustryRelated}
     * @memberof MyApplicationEducationIndustryRelated
     */
    educationIndustry?: EducationIndustryRelated;
}
/**
 * Iðngrein á eigin umsókn.
 * @export
 * @interface MyApplicationEducationIndustryRelatedRequest
 */
export interface MyApplicationEducationIndustryRelatedRequest {
    /**
     * 
     * @type {EducationIndustryRelatedRequest}
     * @memberof MyApplicationEducationIndustryRelatedRequest
     */
    educationIndustry?: EducationIndustryRelatedRequest;
}
/**
 * Önnur menntun á eigin umsókn.
 * @export
 * @interface MyApplicationEducationOther
 */
export interface MyApplicationEducationOther {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationEducationOther
     */
    id: string;
    /**
     * 
     * @type {EducationOtherRelated}
     * @memberof MyApplicationEducationOther
     */
    educationOther?: EducationOtherRelated;
}
/**
 * Önnur menntun á eigin umsókn.
 * @export
 * @interface MyApplicationEducationOtherRequest
 */
export interface MyApplicationEducationOtherRequest {
    /**
     * 
     * @type {EducationOtherRelatedRequest}
     * @memberof MyApplicationEducationOtherRequest
     */
    educationOther?: EducationOtherRelatedRequest;
}
/**
 * Skrá á eigin umsókn.
 * @export
 * @interface MyApplicationFile
 */
export interface MyApplicationFile {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationFile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationFile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationFile
     */
    file: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationFile
     */
    isPensionfundFile?: boolean;
}
/**
 * Skrá á eigin umsókn.
 * @export
 * @interface MyApplicationFileRequest
 */
export interface MyApplicationFileRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationFileRequest
     */
    isPensionfundFile?: boolean;
}
/**
 * Starfsreynsla á eigin umsókn.
 * @export
 * @interface MyApplicationJob
 */
export interface MyApplicationJob {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJob
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJob
     */
    company: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJob
     */
    job: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJob
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJob
     */
    dateFrom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJob
     */
    dateTo?: string | null;
}
/**
 * Starfsreynsla á eigin umsókn.
 * @export
 * @interface MyApplicationJobRequest
 */
export interface MyApplicationJobRequest {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJobRequest
     */
    company: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJobRequest
     */
    job: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJobRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJobRequest
     */
    dateFrom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationJobRequest
     */
    dateTo?: string | null;
}
/**
 * Listi yfir mínar umsóknir
 * @export
 * @interface MyApplicationList
 */
export interface MyApplicationList {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    id: string;
    /**
     * 
     * @type {ApplicationStatusEnum}
     * @memberof MyApplicationList
     */
    status?: ApplicationStatusEnum;
    /**
     * 
     * @type {IndustryRelated}
     * @memberof MyApplicationList
     */
    industry: IndustryRelated;
    /**
     * 
     * @type {SchoolRelated}
     * @memberof MyApplicationList
     */
    school: SchoolRelated;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    applicationQuestionnaireId?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    applicationQuestionnaireStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    applicationQuestionnaireInterviewLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    applicationQuestionnaireInterviewDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    interviewLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    interviewDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationList
     */
    createdAt?: string;
}
/**
 * Hlaða upp skrá á eigin umsókn
 * @export
 * @interface MyApplicationUploadFile
 */
export interface MyApplicationUploadFile {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationUploadFile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationUploadFile
     */
    file: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationUploadFile
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyApplicationUploadFile
     */
    isPensionfundFile?: boolean;
}
/**
 * Notandi á eigin umsókn.
 * @export
 * @interface MyApplicationUser
 */
export interface MyApplicationUser {
    /**
     * 
     * @type {string}
     * @memberof MyApplicationUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationUser
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MyApplicationUser
     */
    username: string;
}
/**
 * Sækir upplýsingar úr námsferli umsækjanda.
 * @export
 * @interface MyInnaEducation
 */
export interface MyInnaEducation {
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    skoliAudk?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    onnEink?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    dagsLokid?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    namsgreinAfanganr?: string;
    /**
     * 
     * @type {number}
     * @memberof MyInnaEducation
     */
    trep: number;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    einkunn: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    einingarFerill?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    stadaAfanga?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    undirskHeiti?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    undirskAudk?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInnaEducation
     */
    namsgreinHeiti?: string;
}
/**
 * Mínar umsóknir
 * @export
 * @interface PatchedMyApplicationDetailRequest
 */
export interface PatchedMyApplicationDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedMyApplicationDetailRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMyApplicationDetailRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMyApplicationDetailRequest
     */
    mobile?: string;
    /**
     * 
     * @type {UnionRelatedRequest}
     * @memberof PatchedMyApplicationDetailRequest
     */
    union?: UnionRelatedRequest | null;
    /**
     * 
     * @type {ApplicationStatusEnum}
     * @memberof PatchedMyApplicationDetailRequest
     */
    status?: ApplicationStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationDetailRequest
     */
    hasNoUnion?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationDetailRequest
     */
    dontKnowUnion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedMyApplicationDetailRequest
     */
    interviewLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMyApplicationDetailRequest
     */
    interviewDateTime?: string | null;
    /**
     * 
     * @type {IndustryRelatedRequest}
     * @memberof PatchedMyApplicationDetailRequest
     */
    industry?: IndustryRelatedRequest;
    /**
     * 
     * @type {SchoolRelatedRequest}
     * @memberof PatchedMyApplicationDetailRequest
     */
    school?: SchoolRelatedRequest;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationDetailRequest
     */
    isContractFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationDetailRequest
     */
    isJourneymanFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationDetailRequest
     */
    isMatriculationFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationDetailRequest
     */
    isEducationAbroadFinished?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationDetailRequest
     */
    hasOngoingContract?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedMyApplicationDetailRequest
     */
    otherEducationInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedMyApplicationDetailRequest
     */
    otherInformation?: string;
    /**
     * 
     * @type {Array<MyApplicationEducationIndustryRelatedRequest>}
     * @memberof PatchedMyApplicationDetailRequest
     */
    education?: Array<MyApplicationEducationIndustryRelatedRequest>;
    /**
     * 
     * @type {Array<MyApplicationEducationOtherRequest>}
     * @memberof PatchedMyApplicationDetailRequest
     */
    educationOther?: Array<MyApplicationEducationOtherRequest>;
    /**
     * 
     * @type {Array<MyApplicationEducationCourseRequest>}
     * @memberof PatchedMyApplicationDetailRequest
     */
    course?: Array<MyApplicationEducationCourseRequest>;
    /**
     * 
     * @type {Array<MyApplicationJobRequest>}
     * @memberof PatchedMyApplicationDetailRequest
     */
    job?: Array<MyApplicationJobRequest>;
}
/**
 * Skrá á eigin umsókn.
 * @export
 * @interface PatchedMyApplicationFileRequest
 */
export interface PatchedMyApplicationFileRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchedMyApplicationFileRequest
     */
    isPensionfundFile?: boolean;
}
/**
 * Matslisti tengdur svarlista
 * @export
 * @interface QuestionnaireRelated
 */
export interface QuestionnaireRelated {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireRelated
     */
    id: string;
    /**
     * 
     * @type {QuestionnaireStatusEnum}
     * @memberof QuestionnaireRelated
     */
    status: QuestionnaireStatusEnum;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum QuestionnaireStatusEnum {
    Draft = 'DRAFT',
    Published = 'PUBLISHED'
}

/**
 * 
 * @export
 * @interface SchoolMetadataIndustryRelated
 */
export interface SchoolMetadataIndustryRelated {
    /**
     * 
     * @type {string}
     * @memberof SchoolMetadataIndustryRelated
     */
    id: string;
    /**
     * 
     * @type {IndustryRelated}
     * @memberof SchoolMetadataIndustryRelated
     */
    industry: IndustryRelated;
}
/**
 * 
 * @export
 * @interface SchoolRelated
 */
export interface SchoolRelated {
    /**
     * 
     * @type {number}
     * @memberof SchoolRelated
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SchoolRelated
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SchoolRelated
     */
    abbr: string;
}
/**
 * 
 * @export
 * @interface SchoolRelatedRequest
 */
export interface SchoolRelatedRequest {
    /**
     * 
     * @type {number}
     * @memberof SchoolRelatedRequest
     */
    id: number;
}
/**
 * 
 * @export
 * @interface Term
 */
export interface Term {
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    textHtml?: string;
    /**
     * 
     * @type {string}
     * @memberof Term
     */
    acceptedAt?: string;
}
/**
 * Notandi samþykkir skilmála
 * @export
 * @interface TermAccept
 */
export interface TermAccept {
    /**
     * 
     * @type {string}
     * @memberof TermAccept
     */
    dateAccepted?: string;
}
/**
 * Hefur innskráður notandi samþykkt skilmála
 * @export
 * @interface TermIsAccepted
 */
export interface TermIsAccepted {
    /**
     * 
     * @type {string}
     * @memberof TermIsAccepted
     */
    acceptedAt?: string;
}
/**
 * 
 * @export
 * @interface UnionRelated
 */
export interface UnionRelated {
    /**
     * 
     * @type {string}
     * @memberof UnionRelated
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UnionRelated
     */
    name: string;
}
/**
 * 
 * @export
 * @interface UnionRelatedRequest
 */
export interface UnionRelatedRequest {
    /**
     * 
     * @type {string}
     * @memberof UnionRelatedRequest
     */
    id: string;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sækja innskráðan notanda
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/account/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Skrá út
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/account/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tryggja að CSRF kóði sé settur.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCsrf: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/account/set-csrf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Notandi samþykkir skilmála
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termAccept: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('termAccept', 'uuid', uuid)
            const localVarPath = `/application-v1/account/term/{uuid}/accept/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hefur innskráður notandi samþykkt skilmála
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termIsAccepted: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('termIsAccepted', 'uuid', uuid)
            const localVarPath = `/application-v1/account/term/{uuid}/is_accepted/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Notandi getur sótt og samþykkt skilmála.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termRetrieve: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('termRetrieve', 'uuid', uuid)
            const localVarPath = `/application-v1/account/term/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * Sækja innskráðan notanda
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMe>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Skrá út
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Tryggja að CSRF kóði sé settur.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCsrf(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCsrf(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Notandi samþykkir skilmála
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termAccept(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermAccept>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termAccept(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Hefur innskráður notandi samþykkt skilmála
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termIsAccepted(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermIsAccepted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termIsAccepted(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Notandi getur sótt og samþykkt skilmála.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async termRetrieve(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Term>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.termRetrieve(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * Sækja innskráðan notanda
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options?: any): AxiosPromise<GetMe> {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         * Skrá út
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Tryggja að CSRF kóði sé settur.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCsrf(options?: any): AxiosPromise<void> {
            return localVarFp.setCsrf(options).then((request) => request(axios, basePath));
        },
        /**
         * Notandi samþykkir skilmála
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termAccept(uuid: string, options?: any): AxiosPromise<TermAccept> {
            return localVarFp.termAccept(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Hefur innskráður notandi samþykkt skilmála
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termIsAccepted(uuid: string, options?: any): AxiosPromise<TermIsAccepted> {
            return localVarFp.termIsAccepted(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Notandi getur sótt og samþykkt skilmála.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        termRetrieve(uuid: string, options?: any): AxiosPromise<Term> {
            return localVarFp.termRetrieve(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for termAccept operation in AccountApi.
 * @export
 * @interface AccountApiTermAcceptRequest
 */
export interface AccountApiTermAcceptRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiTermAccept
     */
    readonly uuid: string
}

/**
 * Request parameters for termIsAccepted operation in AccountApi.
 * @export
 * @interface AccountApiTermIsAcceptedRequest
 */
export interface AccountApiTermIsAcceptedRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiTermIsAccepted
     */
    readonly uuid: string
}

/**
 * Request parameters for termRetrieve operation in AccountApi.
 * @export
 * @interface AccountApiTermRetrieveRequest
 */
export interface AccountApiTermRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiTermRetrieve
     */
    readonly uuid: string
}

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * Sækja innskráðan notanda
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getMe(options?: any) {
        return AccountApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Skrá út
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public logout(options?: any) {
        return AccountApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tryggja að CSRF kóði sé settur.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public setCsrf(options?: any) {
        return AccountApiFp(this.configuration).setCsrf(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Notandi samþykkir skilmála
     * @param {AccountApiTermAcceptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public termAccept(requestParameters: AccountApiTermAcceptRequest, options?: any) {
        return AccountApiFp(this.configuration).termAccept(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hefur innskráður notandi samþykkt skilmála
     * @param {AccountApiTermIsAcceptedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public termIsAccepted(requestParameters: AccountApiTermIsAcceptedRequest, options?: any) {
        return AccountApiFp(this.configuration).termIsAccepted(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Notandi getur sótt og samþykkt skilmála.
     * @param {AccountApiTermRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public termRetrieve(requestParameters: AccountApiTermRetrieveRequest, options?: any) {
        return AccountApiFp(this.configuration).termRetrieve(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApplicationApi - axios parameter creator
 * @export
 */
export const ApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Listi yfir sveinsprófsgreinar fyrir menntun í umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationEducationIndustryList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/application/application-education-industry/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Listi yfir aðrar greinar fyrir menntun í umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationEducationOtherList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/application/application-education-other/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Listi yfir iðngreinar fyrir umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationIndustryList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/application/application-industry/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Virkja umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationActivate: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationMyApplicationActivate', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{uuid}/activate/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hætta við umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationCancel: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationMyApplicationCancel', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{uuid}/cancel/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Senda inn umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationComplete: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationMyApplicationComplete', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{uuid}/complete/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endursenda inn umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationResubmit: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationMyApplicationResubmit', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{uuid}/resubmit/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hlaða upp skrá.
         * @param {string} uuid 
         * @param {any} file 
         * @param {string} name 
         * @param {boolean} [isPensionfundFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationUploadFile: async (uuid: string, file: any, name: string, isPensionfundFile?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationMyApplicationUploadFile', 'uuid', uuid)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('applicationMyApplicationUploadFile', 'file', file)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('applicationMyApplicationUploadFile', 'name', name)
            const localVarPath = `/application-v1/application/my-application/{uuid}/upload-file/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (isPensionfundFile !== undefined) { 
                localVarFormParams.append('isPensionfundFile', isPensionfundFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sækja menntun fyrir umsókn
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyInnaEducation: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationMyInnaEducation', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{uuid}/my_inna_education/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Listi yfir skóla fyrir umsókn.
         * @param {string} [industry] industry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationSchoolList: async (industry?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/application/application-school/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            if (industry !== undefined) {
                localVarQueryParameter['industry'] = industry;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Listi yfir stéttarfélög fyrir umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationUnionList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/application/application-union/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með comment á umsókn umsækjanda.
         * @param {string} application 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationCommentList: async (application: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'application' is not null or undefined
            assertParamExists('myApplicationCommentList', 'application', application)
            const localVarPath = `/application-v1/application/my-application/{application}/comment/`
                .replace(`{${"application"}}`, encodeURIComponent(String(application)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með comment á umsókn umsækjanda.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationCommentRetrieve: async (application: string, uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'application' is not null or undefined
            assertParamExists('myApplicationCommentRetrieve', 'application', application)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationCommentRetrieve', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{application}/comment/{uuid}/`
                .replace(`{${"application"}}`, encodeURIComponent(String(application)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {MyApplicationDetailRequest} myApplicationDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationCreate: async (myApplicationDetailRequest: MyApplicationDetailRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'myApplicationDetailRequest' is not null or undefined
            assertParamExists('myApplicationCreate', 'myApplicationDetailRequest', myApplicationDetailRequest)
            const localVarPath = `/application-v1/application/my-application/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(myApplicationDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFileDestroy: async (application: string, uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'application' is not null or undefined
            assertParamExists('myApplicationFileDestroy', 'application', application)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationFileDestroy', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{application}/file/{uuid}/`
                .replace(`{${"application"}}`, encodeURIComponent(String(application)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sækja skrá.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFileDownload: async (application: string, uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'application' is not null or undefined
            assertParamExists('myApplicationFileDownload', 'application', application)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationFileDownload', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{application}/file/{uuid}/download-file/`
                .replace(`{${"application"}}`, encodeURIComponent(String(application)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {PatchedMyApplicationFileRequest} [patchedMyApplicationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFilePartialUpdate: async (application: string, uuid: string, patchedMyApplicationFileRequest?: PatchedMyApplicationFileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'application' is not null or undefined
            assertParamExists('myApplicationFilePartialUpdate', 'application', application)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationFilePartialUpdate', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{application}/file/{uuid}/`
                .replace(`{${"application"}}`, encodeURIComponent(String(application)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedMyApplicationFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {MyApplicationFileRequest} [myApplicationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFileUpdate: async (application: string, uuid: string, myApplicationFileRequest?: MyApplicationFileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'application' is not null or undefined
            assertParamExists('myApplicationFileUpdate', 'application', application)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationFileUpdate', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{application}/file/{uuid}/`
                .replace(`{${"application"}}`, encodeURIComponent(String(application)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(myApplicationFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/application/my-application/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {PatchedMyApplicationDetailRequest} [patchedMyApplicationDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationPartialUpdate: async (uuid: string, patchedMyApplicationDetailRequest?: PatchedMyApplicationDetailRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationPartialUpdate', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedMyApplicationDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationRetrieve: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationRetrieve', 'uuid', uuid)
            const localVarPath = `/application-v1/application/my-application/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {MyApplicationDetailRequest} myApplicationDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationUpdate: async (uuid: string, myApplicationDetailRequest: MyApplicationDetailRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('myApplicationUpdate', 'uuid', uuid)
            // verify required parameter 'myApplicationDetailRequest' is not null or undefined
            assertParamExists('myApplicationUpdate', 'myApplicationDetailRequest', myApplicationDetailRequest)
            const localVarPath = `/application-v1/application/my-application/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(myApplicationDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með námsferil úr INNU á umsókn umsækjanda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myInnaEducation: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/application/inna-education`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationApi - functional programming interface
 * @export
 */
export const ApplicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationApiAxiosParamCreator(configuration)
    return {
        /**
         * Listi yfir sveinsprófsgreinar fyrir menntun í umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationEducationIndustryList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEducationIndustry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationEducationIndustryList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Listi yfir aðrar greinar fyrir menntun í umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationEducationOtherList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEducationOther>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationEducationOtherList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Listi yfir iðngreinar fyrir umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationIndustryList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationIndustry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationIndustryList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Virkja umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationMyApplicationActivate(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationMyApplicationActivate(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Hætta við umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationMyApplicationCancel(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationMyApplicationCancel(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Senda inn umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationMyApplicationComplete(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationMyApplicationComplete(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endursenda inn umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationMyApplicationResubmit(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationMyApplicationResubmit(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Hlaða upp skrá.
         * @param {string} uuid 
         * @param {any} file 
         * @param {string} name 
         * @param {boolean} [isPensionfundFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationMyApplicationUploadFile(uuid: string, file: any, name: string, isPensionfundFile?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationUploadFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationMyApplicationUploadFile(uuid, file, name, isPensionfundFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sækja menntun fyrir umsókn
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationMyInnaEducation(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MyInnaEducation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationMyInnaEducation(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Listi yfir skóla fyrir umsókn.
         * @param {string} [industry] industry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationSchoolList(industry?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationSchool>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationSchoolList(industry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Listi yfir stéttarfélög fyrir umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationUnionList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUnion>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationUnionList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með comment á umsókn umsækjanda.
         * @param {string} application 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationCommentList(application: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MyApplicationComment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationCommentList(application, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með comment á umsókn umsækjanda.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationCommentRetrieve(application: string, uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationComment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationCommentRetrieve(application, uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {MyApplicationDetailRequest} myApplicationDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationCreate(myApplicationDetailRequest: MyApplicationDetailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationCreate(myApplicationDetailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationFileDestroy(application: string, uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationFileDestroy(application, uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sækja skrá.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationFileDownload(application: string, uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationFileDownload(application, uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {PatchedMyApplicationFileRequest} [patchedMyApplicationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationFilePartialUpdate(application: string, uuid: string, patchedMyApplicationFileRequest?: PatchedMyApplicationFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationFilePartialUpdate(application, uuid, patchedMyApplicationFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {MyApplicationFileRequest} [myApplicationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationFileUpdate(application: string, uuid: string, myApplicationFileRequest?: MyApplicationFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationFileUpdate(application, uuid, myApplicationFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MyApplicationList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {PatchedMyApplicationDetailRequest} [patchedMyApplicationDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationPartialUpdate(uuid: string, patchedMyApplicationDetailRequest?: PatchedMyApplicationDetailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationPartialUpdate(uuid, patchedMyApplicationDetailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationRetrieve(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationRetrieve(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {MyApplicationDetailRequest} myApplicationDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myApplicationUpdate(uuid: string, myApplicationDetailRequest: MyApplicationDetailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyApplicationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myApplicationUpdate(uuid, myApplicationDetailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með námsferil úr INNU á umsókn umsækjanda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myInnaEducation(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MyInnaEducation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myInnaEducation(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationApi - factory interface
 * @export
 */
export const ApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationApiFp(configuration)
    return {
        /**
         * Listi yfir sveinsprófsgreinar fyrir menntun í umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationEducationIndustryList(options?: any): AxiosPromise<Array<ApplicationEducationIndustry>> {
            return localVarFp.applicationEducationIndustryList(options).then((request) => request(axios, basePath));
        },
        /**
         * Listi yfir aðrar greinar fyrir menntun í umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationEducationOtherList(options?: any): AxiosPromise<Array<ApplicationEducationOther>> {
            return localVarFp.applicationEducationOtherList(options).then((request) => request(axios, basePath));
        },
        /**
         * Listi yfir iðngreinar fyrir umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationIndustryList(options?: any): AxiosPromise<Array<ApplicationIndustry>> {
            return localVarFp.applicationIndustryList(options).then((request) => request(axios, basePath));
        },
        /**
         * Virkja umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationActivate(uuid: string, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.applicationMyApplicationActivate(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Hætta við umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationCancel(uuid: string, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.applicationMyApplicationCancel(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Senda inn umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationComplete(uuid: string, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.applicationMyApplicationComplete(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Endursenda inn umsókn.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationResubmit(uuid: string, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.applicationMyApplicationResubmit(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Hlaða upp skrá.
         * @param {string} uuid 
         * @param {any} file 
         * @param {string} name 
         * @param {boolean} [isPensionfundFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyApplicationUploadFile(uuid: string, file: any, name: string, isPensionfundFile?: boolean, options?: any): AxiosPromise<MyApplicationUploadFile> {
            return localVarFp.applicationMyApplicationUploadFile(uuid, file, name, isPensionfundFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Sækja menntun fyrir umsókn
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationMyInnaEducation(uuid: string, options?: any): AxiosPromise<Array<MyInnaEducation>> {
            return localVarFp.applicationMyInnaEducation(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Listi yfir skóla fyrir umsókn.
         * @param {string} [industry] industry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationSchoolList(industry?: string, options?: any): AxiosPromise<Array<ApplicationSchool>> {
            return localVarFp.applicationSchoolList(industry, options).then((request) => request(axios, basePath));
        },
        /**
         * Listi yfir stéttarfélög fyrir umsókn.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationUnionList(options?: any): AxiosPromise<Array<ApplicationUnion>> {
            return localVarFp.applicationUnionList(options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með comment á umsókn umsækjanda.
         * @param {string} application 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationCommentList(application: string, options?: any): AxiosPromise<Array<MyApplicationComment>> {
            return localVarFp.myApplicationCommentList(application, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með comment á umsókn umsækjanda.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationCommentRetrieve(application: string, uuid: string, options?: any): AxiosPromise<MyApplicationComment> {
            return localVarFp.myApplicationCommentRetrieve(application, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {MyApplicationDetailRequest} myApplicationDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationCreate(myApplicationDetailRequest: MyApplicationDetailRequest, options?: any): AxiosPromise<MyApplicationDetail> {
            return localVarFp.myApplicationCreate(myApplicationDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFileDestroy(application: string, uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.myApplicationFileDestroy(application, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Sækja skrá.
         * @param {string} application 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFileDownload(application: string, uuid: string, options?: any): AxiosPromise<any> {
            return localVarFp.myApplicationFileDownload(application, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {PatchedMyApplicationFileRequest} [patchedMyApplicationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFilePartialUpdate(application: string, uuid: string, patchedMyApplicationFileRequest?: PatchedMyApplicationFileRequest, options?: any): AxiosPromise<MyApplicationFile> {
            return localVarFp.myApplicationFilePartialUpdate(application, uuid, patchedMyApplicationFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með skrár á minni umsókn.
         * @param {string} application 
         * @param {string} uuid 
         * @param {MyApplicationFileRequest} [myApplicationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationFileUpdate(application: string, uuid: string, myApplicationFileRequest?: MyApplicationFileRequest, options?: any): AxiosPromise<MyApplicationFile> {
            return localVarFp.myApplicationFileUpdate(application, uuid, myApplicationFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationList(options?: any): AxiosPromise<Array<MyApplicationList>> {
            return localVarFp.myApplicationList(options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {PatchedMyApplicationDetailRequest} [patchedMyApplicationDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationPartialUpdate(uuid: string, patchedMyApplicationDetailRequest?: PatchedMyApplicationDetailRequest, options?: any): AxiosPromise<MyApplicationDetail> {
            return localVarFp.myApplicationPartialUpdate(uuid, patchedMyApplicationDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationRetrieve(uuid: string, options?: any): AxiosPromise<MyApplicationDetail> {
            return localVarFp.myApplicationRetrieve(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með umsóknir umsækjanda.
         * @param {string} uuid 
         * @param {MyApplicationDetailRequest} myApplicationDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myApplicationUpdate(uuid: string, myApplicationDetailRequest: MyApplicationDetailRequest, options?: any): AxiosPromise<MyApplicationDetail> {
            return localVarFp.myApplicationUpdate(uuid, myApplicationDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með námsferil úr INNU á umsókn umsækjanda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myInnaEducation(options?: any): AxiosPromise<Array<MyInnaEducation>> {
            return localVarFp.myInnaEducation(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for applicationMyApplicationActivate operation in ApplicationApi.
 * @export
 * @interface ApplicationApiApplicationMyApplicationActivateRequest
 */
export interface ApplicationApiApplicationMyApplicationActivateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiApplicationMyApplicationActivate
     */
    readonly uuid: string
}

/**
 * Request parameters for applicationMyApplicationCancel operation in ApplicationApi.
 * @export
 * @interface ApplicationApiApplicationMyApplicationCancelRequest
 */
export interface ApplicationApiApplicationMyApplicationCancelRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiApplicationMyApplicationCancel
     */
    readonly uuid: string
}

/**
 * Request parameters for applicationMyApplicationComplete operation in ApplicationApi.
 * @export
 * @interface ApplicationApiApplicationMyApplicationCompleteRequest
 */
export interface ApplicationApiApplicationMyApplicationCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiApplicationMyApplicationComplete
     */
    readonly uuid: string
}

/**
 * Request parameters for applicationMyApplicationResubmit operation in ApplicationApi.
 * @export
 * @interface ApplicationApiApplicationMyApplicationResubmitRequest
 */
export interface ApplicationApiApplicationMyApplicationResubmitRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiApplicationMyApplicationResubmit
     */
    readonly uuid: string
}

/**
 * Request parameters for applicationMyApplicationUploadFile operation in ApplicationApi.
 * @export
 * @interface ApplicationApiApplicationMyApplicationUploadFileRequest
 */
export interface ApplicationApiApplicationMyApplicationUploadFileRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiApplicationMyApplicationUploadFile
     */
    readonly uuid: string

    /**
     * 
     * @type {any}
     * @memberof ApplicationApiApplicationMyApplicationUploadFile
     */
    readonly file: any

    /**
     * 
     * @type {string}
     * @memberof ApplicationApiApplicationMyApplicationUploadFile
     */
    readonly name: string

    /**
     * 
     * @type {boolean}
     * @memberof ApplicationApiApplicationMyApplicationUploadFile
     */
    readonly isPensionfundFile?: boolean
}

/**
 * Request parameters for applicationMyInnaEducation operation in ApplicationApi.
 * @export
 * @interface ApplicationApiApplicationMyInnaEducationRequest
 */
export interface ApplicationApiApplicationMyInnaEducationRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiApplicationMyInnaEducation
     */
    readonly uuid: string
}

/**
 * Request parameters for applicationSchoolList operation in ApplicationApi.
 * @export
 * @interface ApplicationApiApplicationSchoolListRequest
 */
export interface ApplicationApiApplicationSchoolListRequest {
    /**
     * industry
     * @type {string}
     * @memberof ApplicationApiApplicationSchoolList
     */
    readonly industry?: string
}

/**
 * Request parameters for myApplicationCommentList operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationCommentListRequest
 */
export interface ApplicationApiMyApplicationCommentListRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationCommentList
     */
    readonly application: string
}

/**
 * Request parameters for myApplicationCommentRetrieve operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationCommentRetrieveRequest
 */
export interface ApplicationApiMyApplicationCommentRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationCommentRetrieve
     */
    readonly application: string

    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationCommentRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for myApplicationCreate operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationCreateRequest
 */
export interface ApplicationApiMyApplicationCreateRequest {
    /**
     * 
     * @type {MyApplicationDetailRequest}
     * @memberof ApplicationApiMyApplicationCreate
     */
    readonly myApplicationDetailRequest: MyApplicationDetailRequest
}

/**
 * Request parameters for myApplicationFileDestroy operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationFileDestroyRequest
 */
export interface ApplicationApiMyApplicationFileDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFileDestroy
     */
    readonly application: string

    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFileDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for myApplicationFileDownload operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationFileDownloadRequest
 */
export interface ApplicationApiMyApplicationFileDownloadRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFileDownload
     */
    readonly application: string

    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFileDownload
     */
    readonly uuid: string
}

/**
 * Request parameters for myApplicationFilePartialUpdate operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationFilePartialUpdateRequest
 */
export interface ApplicationApiMyApplicationFilePartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFilePartialUpdate
     */
    readonly application: string

    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFilePartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedMyApplicationFileRequest}
     * @memberof ApplicationApiMyApplicationFilePartialUpdate
     */
    readonly patchedMyApplicationFileRequest?: PatchedMyApplicationFileRequest
}

/**
 * Request parameters for myApplicationFileUpdate operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationFileUpdateRequest
 */
export interface ApplicationApiMyApplicationFileUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFileUpdate
     */
    readonly application: string

    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationFileUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {MyApplicationFileRequest}
     * @memberof ApplicationApiMyApplicationFileUpdate
     */
    readonly myApplicationFileRequest?: MyApplicationFileRequest
}

/**
 * Request parameters for myApplicationPartialUpdate operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationPartialUpdateRequest
 */
export interface ApplicationApiMyApplicationPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedMyApplicationDetailRequest}
     * @memberof ApplicationApiMyApplicationPartialUpdate
     */
    readonly patchedMyApplicationDetailRequest?: PatchedMyApplicationDetailRequest
}

/**
 * Request parameters for myApplicationRetrieve operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationRetrieveRequest
 */
export interface ApplicationApiMyApplicationRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for myApplicationUpdate operation in ApplicationApi.
 * @export
 * @interface ApplicationApiMyApplicationUpdateRequest
 */
export interface ApplicationApiMyApplicationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationApiMyApplicationUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {MyApplicationDetailRequest}
     * @memberof ApplicationApiMyApplicationUpdate
     */
    readonly myApplicationDetailRequest: MyApplicationDetailRequest
}

/**
 * ApplicationApi - object-oriented interface
 * @export
 * @class ApplicationApi
 * @extends {BaseAPI}
 */
export class ApplicationApi extends BaseAPI {
    /**
     * Listi yfir sveinsprófsgreinar fyrir menntun í umsókn.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationEducationIndustryList(options?: any) {
        return ApplicationApiFp(this.configuration).applicationEducationIndustryList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Listi yfir aðrar greinar fyrir menntun í umsókn.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationEducationOtherList(options?: any) {
        return ApplicationApiFp(this.configuration).applicationEducationOtherList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Listi yfir iðngreinar fyrir umsókn.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationIndustryList(options?: any) {
        return ApplicationApiFp(this.configuration).applicationIndustryList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Virkja umsókn.
     * @param {ApplicationApiApplicationMyApplicationActivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationMyApplicationActivate(requestParameters: ApplicationApiApplicationMyApplicationActivateRequest, options?: any) {
        return ApplicationApiFp(this.configuration).applicationMyApplicationActivate(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hætta við umsókn.
     * @param {ApplicationApiApplicationMyApplicationCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationMyApplicationCancel(requestParameters: ApplicationApiApplicationMyApplicationCancelRequest, options?: any) {
        return ApplicationApiFp(this.configuration).applicationMyApplicationCancel(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Senda inn umsókn.
     * @param {ApplicationApiApplicationMyApplicationCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationMyApplicationComplete(requestParameters: ApplicationApiApplicationMyApplicationCompleteRequest, options?: any) {
        return ApplicationApiFp(this.configuration).applicationMyApplicationComplete(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endursenda inn umsókn.
     * @param {ApplicationApiApplicationMyApplicationResubmitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationMyApplicationResubmit(requestParameters: ApplicationApiApplicationMyApplicationResubmitRequest, options?: any) {
        return ApplicationApiFp(this.configuration).applicationMyApplicationResubmit(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hlaða upp skrá.
     * @param {ApplicationApiApplicationMyApplicationUploadFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationMyApplicationUploadFile(requestParameters: ApplicationApiApplicationMyApplicationUploadFileRequest, options?: any) {
        return ApplicationApiFp(this.configuration).applicationMyApplicationUploadFile(requestParameters.uuid, requestParameters.file, requestParameters.name, requestParameters.isPensionfundFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sækja menntun fyrir umsókn
     * @param {ApplicationApiApplicationMyInnaEducationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationMyInnaEducation(requestParameters: ApplicationApiApplicationMyInnaEducationRequest, options?: any) {
        return ApplicationApiFp(this.configuration).applicationMyInnaEducation(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Listi yfir skóla fyrir umsókn.
     * @param {ApplicationApiApplicationSchoolListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationSchoolList(requestParameters: ApplicationApiApplicationSchoolListRequest = {}, options?: any) {
        return ApplicationApiFp(this.configuration).applicationSchoolList(requestParameters.industry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Listi yfir stéttarfélög fyrir umsókn.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public applicationUnionList(options?: any) {
        return ApplicationApiFp(this.configuration).applicationUnionList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með comment á umsókn umsækjanda.
     * @param {ApplicationApiMyApplicationCommentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationCommentList(requestParameters: ApplicationApiMyApplicationCommentListRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationCommentList(requestParameters.application, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með comment á umsókn umsækjanda.
     * @param {ApplicationApiMyApplicationCommentRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationCommentRetrieve(requestParameters: ApplicationApiMyApplicationCommentRetrieveRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationCommentRetrieve(requestParameters.application, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með umsóknir umsækjanda.
     * @param {ApplicationApiMyApplicationCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationCreate(requestParameters: ApplicationApiMyApplicationCreateRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationCreate(requestParameters.myApplicationDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með skrár á minni umsókn.
     * @param {ApplicationApiMyApplicationFileDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationFileDestroy(requestParameters: ApplicationApiMyApplicationFileDestroyRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationFileDestroy(requestParameters.application, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sækja skrá.
     * @param {ApplicationApiMyApplicationFileDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationFileDownload(requestParameters: ApplicationApiMyApplicationFileDownloadRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationFileDownload(requestParameters.application, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með skrár á minni umsókn.
     * @param {ApplicationApiMyApplicationFilePartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationFilePartialUpdate(requestParameters: ApplicationApiMyApplicationFilePartialUpdateRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationFilePartialUpdate(requestParameters.application, requestParameters.uuid, requestParameters.patchedMyApplicationFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með skrár á minni umsókn.
     * @param {ApplicationApiMyApplicationFileUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationFileUpdate(requestParameters: ApplicationApiMyApplicationFileUpdateRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationFileUpdate(requestParameters.application, requestParameters.uuid, requestParameters.myApplicationFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með umsóknir umsækjanda.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationList(options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með umsóknir umsækjanda.
     * @param {ApplicationApiMyApplicationPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationPartialUpdate(requestParameters: ApplicationApiMyApplicationPartialUpdateRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationPartialUpdate(requestParameters.uuid, requestParameters.patchedMyApplicationDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með umsóknir umsækjanda.
     * @param {ApplicationApiMyApplicationRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationRetrieve(requestParameters: ApplicationApiMyApplicationRetrieveRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationRetrieve(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með umsóknir umsækjanda.
     * @param {ApplicationApiMyApplicationUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myApplicationUpdate(requestParameters: ApplicationApiMyApplicationUpdateRequest, options?: any) {
        return ApplicationApiFp(this.configuration).myApplicationUpdate(requestParameters.uuid, requestParameters.myApplicationDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með námsferil úr INNU á umsókn umsækjanda.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    public myInnaEducation(options?: any) {
        return ApplicationApiFp(this.configuration).myInnaEducation(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuestionnaireApi - axios parameter creator
 * @export
 */
export const QuestionnaireApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Svara spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireAnswer: async (uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationQuestionnaireAnswer', 'uuid', uuid)
            // verify required parameter 'applicationQuestionnaireAnswerInputRequest' is not null or undefined
            assertParamExists('applicationQuestionnaireAnswer', 'applicationQuestionnaireAnswerInputRequest', applicationQuestionnaireAnswerInputRequest)
            const localVarPath = `/application-v1/questionnaire/application-questionnaire/{uuid}/answer/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationQuestionnaireAnswerInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {ApplicationQuestionnaireDetailRequest} applicationQuestionnaireDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireCreate: async (applicationQuestionnaireDetailRequest: ApplicationQuestionnaireDetailRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationQuestionnaireDetailRequest' is not null or undefined
            assertParamExists('applicationQuestionnaireCreate', 'applicationQuestionnaireDetailRequest', applicationQuestionnaireDetailRequest)
            const localVarPath = `/application-v1/questionnaire/application-questionnaire/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationQuestionnaireDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Klára/Senda inn spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireFinish: async (uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationQuestionnaireFinish', 'uuid', uuid)
            // verify required parameter 'applicationQuestionnaireAnswerInputRequest' is not null or undefined
            assertParamExists('applicationQuestionnaireFinish', 'applicationQuestionnaireAnswerInputRequest', applicationQuestionnaireAnswerInputRequest)
            const localVarPath = `/application-v1/questionnaire/application-questionnaire/{uuid}/finish/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationQuestionnaireAnswerInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireList: async (limit?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/application-v1/questionnaire/application-questionnaire/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endursenda inn spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireResubmit: async (uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationQuestionnaireResubmit', 'uuid', uuid)
            // verify required parameter 'applicationQuestionnaireAnswerInputRequest' is not null or undefined
            assertParamExists('applicationQuestionnaireResubmit', 'applicationQuestionnaireAnswerInputRequest', applicationQuestionnaireAnswerInputRequest)
            const localVarPath = `/application-v1/questionnaire/application-questionnaire/{uuid}/resubmit/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationQuestionnaireAnswerInputRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireRetrieve: async (uuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('applicationQuestionnaireRetrieve', 'uuid', uuid)
            const localVarPath = `/application-v1/questionnaire/application-questionnaire/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnaireApi - functional programming interface
 * @export
 */
export const QuestionnaireApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnaireApiAxiosParamCreator(configuration)
    return {
        /**
         * Svara spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationQuestionnaireAnswer(uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationQuestionnaireAnswer(uuid, applicationQuestionnaireAnswerInputRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {ApplicationQuestionnaireDetailRequest} applicationQuestionnaireDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationQuestionnaireCreate(applicationQuestionnaireDetailRequest: ApplicationQuestionnaireDetailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationQuestionnaireDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationQuestionnaireCreate(applicationQuestionnaireDetailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Klára/Senda inn spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationQuestionnaireFinish(uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationQuestionnaireFinish(uuid, applicationQuestionnaireAnswerInputRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationQuestionnaireList(limit?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationQuestionnaireList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationQuestionnaireList(limit, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endursenda inn spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationQuestionnaireResubmit(uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationQuestionnaireResubmit(uuid, applicationQuestionnaireAnswerInputRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationQuestionnaireRetrieve(uuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationQuestionnaireDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationQuestionnaireRetrieve(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuestionnaireApi - factory interface
 * @export
 */
export const QuestionnaireApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnaireApiFp(configuration)
    return {
        /**
         * Svara spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireAnswer(uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.applicationQuestionnaireAnswer(uuid, applicationQuestionnaireAnswerInputRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {ApplicationQuestionnaireDetailRequest} applicationQuestionnaireDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireCreate(applicationQuestionnaireDetailRequest: ApplicationQuestionnaireDetailRequest, options?: any): AxiosPromise<ApplicationQuestionnaireDetail> {
            return localVarFp.applicationQuestionnaireCreate(applicationQuestionnaireDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Klára/Senda inn spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireFinish(uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.applicationQuestionnaireFinish(uuid, applicationQuestionnaireAnswerInputRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireList(limit?: number, page?: number, options?: any): AxiosPromise<Array<ApplicationQuestionnaireList>> {
            return localVarFp.applicationQuestionnaireList(limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Endursenda inn spurningalista á umsókn.
         * @param {string} uuid 
         * @param {ApplicationQuestionnaireAnswerInputRequest} applicationQuestionnaireAnswerInputRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireResubmit(uuid: string, applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.applicationQuestionnaireResubmit(uuid, applicationQuestionnaireAnswerInputRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sýsla með svör við spurningum á spurningalista.
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationQuestionnaireRetrieve(uuid: string, options?: any): AxiosPromise<ApplicationQuestionnaireDetail> {
            return localVarFp.applicationQuestionnaireRetrieve(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for applicationQuestionnaireAnswer operation in QuestionnaireApi.
 * @export
 * @interface QuestionnaireApiApplicationQuestionnaireAnswerRequest
 */
export interface QuestionnaireApiApplicationQuestionnaireAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireApiApplicationQuestionnaireAnswer
     */
    readonly uuid: string

    /**
     * 
     * @type {ApplicationQuestionnaireAnswerInputRequest}
     * @memberof QuestionnaireApiApplicationQuestionnaireAnswer
     */
    readonly applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest
}

/**
 * Request parameters for applicationQuestionnaireCreate operation in QuestionnaireApi.
 * @export
 * @interface QuestionnaireApiApplicationQuestionnaireCreateRequest
 */
export interface QuestionnaireApiApplicationQuestionnaireCreateRequest {
    /**
     * 
     * @type {ApplicationQuestionnaireDetailRequest}
     * @memberof QuestionnaireApiApplicationQuestionnaireCreate
     */
    readonly applicationQuestionnaireDetailRequest: ApplicationQuestionnaireDetailRequest
}

/**
 * Request parameters for applicationQuestionnaireFinish operation in QuestionnaireApi.
 * @export
 * @interface QuestionnaireApiApplicationQuestionnaireFinishRequest
 */
export interface QuestionnaireApiApplicationQuestionnaireFinishRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireApiApplicationQuestionnaireFinish
     */
    readonly uuid: string

    /**
     * 
     * @type {ApplicationQuestionnaireAnswerInputRequest}
     * @memberof QuestionnaireApiApplicationQuestionnaireFinish
     */
    readonly applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest
}

/**
 * Request parameters for applicationQuestionnaireList operation in QuestionnaireApi.
 * @export
 * @interface QuestionnaireApiApplicationQuestionnaireListRequest
 */
export interface QuestionnaireApiApplicationQuestionnaireListRequest {
    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof QuestionnaireApiApplicationQuestionnaireList
     */
    readonly limit?: number

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof QuestionnaireApiApplicationQuestionnaireList
     */
    readonly page?: number
}

/**
 * Request parameters for applicationQuestionnaireResubmit operation in QuestionnaireApi.
 * @export
 * @interface QuestionnaireApiApplicationQuestionnaireResubmitRequest
 */
export interface QuestionnaireApiApplicationQuestionnaireResubmitRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireApiApplicationQuestionnaireResubmit
     */
    readonly uuid: string

    /**
     * 
     * @type {ApplicationQuestionnaireAnswerInputRequest}
     * @memberof QuestionnaireApiApplicationQuestionnaireResubmit
     */
    readonly applicationQuestionnaireAnswerInputRequest: ApplicationQuestionnaireAnswerInputRequest
}

/**
 * Request parameters for applicationQuestionnaireRetrieve operation in QuestionnaireApi.
 * @export
 * @interface QuestionnaireApiApplicationQuestionnaireRetrieveRequest
 */
export interface QuestionnaireApiApplicationQuestionnaireRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireApiApplicationQuestionnaireRetrieve
     */
    readonly uuid: string
}

/**
 * QuestionnaireApi - object-oriented interface
 * @export
 * @class QuestionnaireApi
 * @extends {BaseAPI}
 */
export class QuestionnaireApi extends BaseAPI {
    /**
     * Svara spurningalista á umsókn.
     * @param {QuestionnaireApiApplicationQuestionnaireAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public applicationQuestionnaireAnswer(requestParameters: QuestionnaireApiApplicationQuestionnaireAnswerRequest, options?: any) {
        return QuestionnaireApiFp(this.configuration).applicationQuestionnaireAnswer(requestParameters.uuid, requestParameters.applicationQuestionnaireAnswerInputRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með svör við spurningum á spurningalista.
     * @param {QuestionnaireApiApplicationQuestionnaireCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public applicationQuestionnaireCreate(requestParameters: QuestionnaireApiApplicationQuestionnaireCreateRequest, options?: any) {
        return QuestionnaireApiFp(this.configuration).applicationQuestionnaireCreate(requestParameters.applicationQuestionnaireDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Klára/Senda inn spurningalista á umsókn.
     * @param {QuestionnaireApiApplicationQuestionnaireFinishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public applicationQuestionnaireFinish(requestParameters: QuestionnaireApiApplicationQuestionnaireFinishRequest, options?: any) {
        return QuestionnaireApiFp(this.configuration).applicationQuestionnaireFinish(requestParameters.uuid, requestParameters.applicationQuestionnaireAnswerInputRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með svör við spurningum á spurningalista.
     * @param {QuestionnaireApiApplicationQuestionnaireListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public applicationQuestionnaireList(requestParameters: QuestionnaireApiApplicationQuestionnaireListRequest = {}, options?: any) {
        return QuestionnaireApiFp(this.configuration).applicationQuestionnaireList(requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endursenda inn spurningalista á umsókn.
     * @param {QuestionnaireApiApplicationQuestionnaireResubmitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public applicationQuestionnaireResubmit(requestParameters: QuestionnaireApiApplicationQuestionnaireResubmitRequest, options?: any) {
        return QuestionnaireApiFp(this.configuration).applicationQuestionnaireResubmit(requestParameters.uuid, requestParameters.applicationQuestionnaireAnswerInputRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sýsla með svör við spurningum á spurningalista.
     * @param {QuestionnaireApiApplicationQuestionnaireRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireApi
     */
    public applicationQuestionnaireRetrieve(requestParameters: QuestionnaireApiApplicationQuestionnaireRetrieveRequest, options?: any) {
        return QuestionnaireApiFp(this.configuration).applicationQuestionnaireRetrieve(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
}


